import { Checkbox } from "@/src/components/ui/checkbox";
import { Footer } from "@/src/components/ui/footer";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/src/components/ui/select";
import { Content } from "@/src/components/wrappers/Content";
import { ActionsContext, useEmit } from "@/src/lib/actions";
import { useEffect, useState } from "react";
import { OptionsTable } from "./OptionsTable";
import { Dialog, DialogContent, DialogTrigger } from "@/src/components/ui/dialog";
import { Button } from "@/src/components/ui/button";
import { PlusIcon } from "lucide-react";
import { EditOption } from "./EditOption";

export function Options() {
  return (
    <ActionsContext>
      <Content
        title="Options"
        contentAction={
          <Dialog>
            <DialogTrigger asChild>
              <Button>
                <PlusIcon size={18} /> Add option
              </Button>
            </DialogTrigger>
            <DialogContent>
              <EditOption />
            </DialogContent>
          </Dialog>
        }
      >
        <div className="mb-2 flex justify-start items-center gap-2">
          <ProviderSelect />
          <SupplierSearch />
          <OnlyOptions />
          <SortSelect />
        </div>
        <OptionsTable />
        <Footer />
      </Content>
    </ActionsContext>
  );
}

function ProviderSelect() {
  const [value, setValue] = useState<"BM" | "NS" | "Helm" | "CYA" | "any">("any");
  const emit = useEmit<"BM" | "NS" | "Helm" | "CYA" | "any">("opt:provider");

  const onValueChange = (value: "BM" | "NS" | "Helm" | "CYA" | "any") => {
    setValue(value);
    emit(value);
  };

  return (
    <div className="w-60">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Provider" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="any">Any provider</SelectItem>
          <SelectItem value="BM">Booking manager</SelectItem>
          <SelectItem value="NS">Nausys</SelectItem>
          <SelectItem value="CYA">CYA</SelectItem>
          <SelectItem value="Helm">Helm</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

function SupplierSearch() {
  const [value, setValue] = useState("");
  const emit = useEmit<string>("opt:supplier");
  // Debounce so we don't refetch on every keystroke.
  useEffect(() => {
    const t = setTimeout(() => emit(value.trim()), 350);
    return () => clearTimeout(t);
  }, [value]);
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Search supplier…"
      className="w-56 border border-slate-200 rounded-md px-3 py-2 text-sm"
    />
  );
}

function OnlyOptions() {
  const [value, setValue] = useState(false);
  const emit = useEmit<boolean>("opt:only-options");

  const onValueChange = (value: boolean) => {
    setValue(value);
    emit(value);
  };

  return (
    <div className="flex gap-2 items-center">
      <Checkbox checked={value} onCheckedChange={(s) => onValueChange(s as boolean)} />
      <label>Only options</label>
    </div>
  );
}
function SortSelect() {
  type options = "charter_asc" | "charter_desc" | "expiration_asc" | "expiration_desc";
  const [value, setValue] = useState<options>("charter_asc");
  const emit = useEmit<options>("opt:sort");

  const onValueChange = (value: options) => {
    setValue(value);
    emit(value);
  };

  return (
    <div className="w-60 ml-auto">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="charter_asc">Sort by: Charter date ascending</SelectItem>
          <SelectItem value="charter_desc">Sort by: Charter date descending</SelectItem>
          <SelectItem value="expiration_asc">Sort by: Expiration date ascending</SelectItem>
          <SelectItem value="expiration_desc">Sort by: Expiration date descending</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
